module.exports = __webpack_public_path__ + "tree-closed.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/tree-closed.svg?color1=%23333333&color2=
// module id = 2216
// module chunks = 67